import cn from '@/utils/cn';
import { getAllowedTermYears } from '@/utils/productTermPricing';

interface TermYearsSelectorProps {
  productCode: string;
  value: number;
  onChange: (years: number) => void;
  className?: string;
  isAumBased?: boolean;
}

export function TermYearsSelector({
  productCode,
  value,
  onChange,
  className,
  isAumBased = false,
}: TermYearsSelectorProps) {
  const options = getAllowedTermYears(productCode, { isAumBased });
  if (options.length <= 1) {
    return null;
  }

  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {options.map((years) => (
        <button
          key={years}
          type="button"
          onClick={() => onChange(years)}
          className={cn(
            'rounded border px-1.5 py-0.5 text-[10px] font-semibold transition-colors',
            value === years
              ? 'border-primary bg-primary/10 text-primary'
              : 'border-border text-muted-foreground hover:border-primary/40 hover:text-foreground',
          )}
          aria-pressed={value === years}
        >
          {years}Y
        </button>
      ))}
    </div>
  );
}
